module.exports = __webpack_public_path__ + "static/media/googleplay-button-icon-black.9a04aab5.png";